import { LOGIN_MESSAGE, RESET } from "../actions/actionTypes";

const initialState = {
  loginMessage: "",
};

export default function requests(state = initialState, action) {
  switch (action.type) {
    case LOGIN_MESSAGE:
      return {
        ...state,
        loginMessage: action.loginMessage,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
}
